<template>
  <div class="ca-download-container">
    <div class="ca-download-grid">
      <div
        v-for="item in downloadList"
        :key="item.id"
        class="ca-download-card"
      >
        <div class="card-icon">
          <i :class="item.icon"></i>
        </div>
        <div class="card-body">
          <div class="card-title">{{ item.title }}</div>
          <div class="card-desc">{{ item.desc }}</div>
        </div>
        <el-button type="primary" size="small" class="download-btn" @click="handleDownload(item)">
          <i class="el-icon-download"></i> 下载
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CaDownload',
  data() {
    return {
      downloadList: [
        {
          id: 1,
          title: 'ESSReader客户端',
          desc: 'ESSReaderClient V4.5.4（已授权），用于证书读取与电子签章',
          icon: 'el-icon-key',
          url: 'https://mfile.vbidding.com/public-downloads/ca%2FESSPDFClient_SetupV4.5.4.rar'
        },
        {
          id: 2,
          title: '证书应用环境安装程序',
          desc: '证书应用环境安装程序 V3.8.6（信步云），CA证书运行依赖环境',
          icon: 'el-icon-cpu',
          url: 'https:/mfile.vbidding.com/public-downloads/ca%2F证书应用环境安装程序V3.8.6(信步云).zip'
        }
      ]
    }
  },
  methods: {
    handleDownload(item) {
      window.open(item.url, '_blank')
    }
  }
}
</script>

<style scoped>
.ca-download-container {
  padding: 8px 0;
}

.ca-download-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.ca-download-card {
  display: flex;
  align-items: center;
  width: calc(50% - 8px);
  box-sizing: border-box;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  padding: 14px 12px;
  background: #fafafa;
  gap: 10px;
}

.card-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #ecf5ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-icon i {
  font-size: 20px;
  color: #409eff;
}

.card-body {
  flex: 1;
  min-width: 0;
}

.card-title {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-desc {
  font-size: 11px;
  color: #909399;
  line-height: 1.4;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.download-btn {
  flex-shrink: 0;
}
</style>
